'use client';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import locales from './locales';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [
      'en',
      'en-IE',
      'en-ie',
      'en-US',
      'en-us',
      'es',
      'es-CL',
      'es-cl',
      'es-CO',
      'es-co',
      'es-EC',
      'es-ec',
      'es-ES',
      'es-es',
      'es-MX',
      'es-mx',
      'es-PA',
      'es-pa',
      'es-PE',
      'es-pe',
      'es-PY',
      'es-py',
      'es-UY',
      'es-uy',
      'de-DE',
      'de-de',
      'pt-BR',
      'pt-br',
      'pt-PT',
      'pt-pt',
      'fr-BE',
      'fr-be',
      'fr-CH',
      'fr-ch',
      'fr-FR',
      'fr-fr',
      'nl-BE',
      'nl-be'
    ],
    resources: locales,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
